<template>
  <div class="pane">
    <slot />
  </div>
</template>

<script lang="ts" setup>

</script>

<style lang="scss" scoped>
.pane {
  @apply bg-white;
  @apply rounded-4;
  @apply px-5;
  @apply py-7.5;
  box-shadow: 0px 3px 6px rgba(44, 40, 40, 0.11);
}
</style>
